module.exports = __webpack_public_path__ + "static/img/ZRS.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/ZRS.png
// module id = Ux6q
// module chunks = 0